// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkspaceLayout_wrapper__RKi4Q"};